export const routes = {
  chunkedUpload: {
    create: '/media/chunked-upload',
    complete: (id: string) => `/media/chunked-upload/${id}/complete`,
    abort: (id: string) => `/media/chunked-upload/${id}/abort`,

    chunk: {
      uploadInfo: (id: string) => `/media/chunked-upload/${id}/chunk`,
      upload: (id: string) => `/media/chunked-upload/${id}/chunk`,
    },
  },
};
